import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralWhite,
    boxShadow: Depths.depth4,
    position: 'absolute',
    left: 0,
    top: '2rem',
    width: '100%',
  },
  loadingSpinner: {
    marginTop: pxToRem(16),
    marginBottom: pxToRem(16),
    paddingLeft: pxToRem(30),
    paddingRight: pxToRem(30),
  },
  moreResults: {
    fontSize: pxToRem(14),
    color: theme.palette.themePrimary,
    padding: '1rem',
  },
  title: {
    fontWeight: 600,
    padding: '1rem 1rem .5rem',
    color: theme.palette.neutralPrimary,
  },
  asterisk: {
    color: theme.palette.accentError,
    paddingLeft: pxToRem(5),
    fontWeight: 600,
  },
  errorMessage: {
    borderColor: theme.palette.accentError,
    color: theme.palette.accentError,
    fontWeight: 400,
    fontSize: pxToRem(12),
    paddingTop: pxToRem(5),
  },
});
